import React from 'react';
import { Carousel, Grid, Typography } from 'antd';
import {
  ArrowRightOutlined,
  CalendarOutlined,
} from '@ant-design/icons';

import '../../../Styles/EventsOutreach.css';
import AppHeader from '../../../Layout/Header';
import FooterComponent from '../../../Layout/Footer';
import SSO from '../../../Assets/Linkages/SpaceAwareness/SSO.jpg';
import CanSatWorkshop from '../../../Assets/Linkages/SpaceAwareness/StudentSatelliteOutreach/02-CanSat-Workshop.jpg';
import CanSatAssembly from '../../../Assets/Linkages/SpaceAwareness/StudentSatelliteOutreach/03-CanSat-Assembly.jpg';
import CanSatFieldActivity from '../../../Assets/Linkages/SpaceAwareness/StudentSatelliteOutreach/04-CanSat-Field-Activity.jpg';
import SpaceScienceDemonstration from '../../../Assets/Linkages/SpaceAwareness/SpaceDestinationSchools/01-Space-Science-Demonstration.jpg';
import SchoolLaboratory from '../../../Assets/Linkages/SpaceAwareness/SpaceDestinationSchools/02-School-Laboratory.jpg';
import KalamStudents from '../../../Assets/Linkages/SpaceAwareness/SpaceDestinationSchools/03-Kalam-Students.jpg';
import HandsOnSchoolActivity from '../../../Assets/Linkages/SpaceAwareness/SpaceDestinationSchools/04-Hands-On-Activity.jpg';
import STEMClassroom from '../../../Assets/Linkages/SpaceAwareness/SpaceDestinationSchools/05-STEM-Classroom.jpg';
import JABH from '../../../Assets/Linkages/SpaceAwareness/JABH.jpg';
import TelefilmPremiereGroup from '../../../Assets/Linkages/SpaceAwareness/SpaceOutreachTelefilm/02-Premiere-Group.jpg';
import TelefilmCastGroup from '../../../Assets/Linkages/SpaceAwareness/SpaceOutreachTelefilm/03-Premiere-Cast-Group.jpg';
import TelefilmPremiereAudience from '../../../Assets/Linkages/SpaceAwareness/SpaceOutreachTelefilm/04-Premiere-Audience.jpg';
import TelefilmPremiereStage from '../../../Assets/Linkages/SpaceAwareness/SpaceOutreachTelefilm/05-Premiere-Stage.jpg';
import WSW2013One from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/01-WSW-2013.jpg';
import WSW2013Two from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/02-WSW-2013.jpg';
import WSW2014One from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/03-WSW-2014.jpg';
import WSW2014Two from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/04-WSW-2014.jpg';
import WSW2015 from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/05-WSW-2015.jpg';
import WSW2016 from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/06-WSW-2016.jpg';
import WSW2017 from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/07-WSW-2017.jpg';
import WSW2018 from '../../../Assets/Linkages/SpaceAwareness/WorldSpaceWeek/GroupPhotos/08-WSW-2018.jpg';
import SummerSchoolOne from '../../../Assets/Linkages/SpaceSummerSchool/Summer-School-01.jpeg';
import SummerSchoolTwo from '../../../Assets/Linkages/SpaceSummerSchool/Summer-School-02.jpg';
import SummerSchoolThree from '../../../Assets/Linkages/SpaceSummerSchool/Summer-School-03.jpg';
import AstronomyCamp from '../../../Assets/Linkages/SpaceAwareness/AstronomyOutreach/01-Astronomy-Camp.jpg';
import AstrophotographyWorkshop from '../../../Assets/Linkages/SpaceAwareness/AstronomyOutreach/02-Astrophotography-Workshop.jpg';
import ISTObservatory from '../../../Assets/Linkages/SpaceAwareness/AstronomyOutreach/03-IST-Observatory.jpg';
import SolarObservation from '../../../Assets/Linkages/SpaceAwareness/AstronomyOutreach/04-Solar-Observation.jpg';
import Stargazing from '../../../Assets/Linkages/SpaceAwareness/AstronomyOutreach/05-Stargazing.jpg';
const { useBreakpoint } = Grid;


const { Title, Paragraph } = Typography;


/* =========================================================
   EVENT DATA
   ========================================================= */

const events = [
  {
    title: 'Space Summer School',
    description:
      'Space Summer School is a flagship STEM-based learning program designed to engage and inspire young learners through immersive experiences in space science and technology. It features hands-on activities, software simulations, and interactive learning across a range of domains, including Astronomy and Astrophysics, Earth and Environmental Sciences, Aviation, Rocketry, and Satellite Technology. By integrating experiential learning with team-based projects, the program aims to spark curiosity, strengthen scientific aptitude, and nurture future leaders in the space ecosystem.',
    images: [SummerSchoolOne, SummerSchoolTwo, SummerSchoolThree],
    link: '/space-summer-school',
  },

  {
    title: 'World Space Week',
    description:
      'World Space Week is a globally recognized celebration of space science, technology, and their impact on society, observed annually from October 4 to 10. In Pakistan, the initiative has grown into a vibrant national movement through a wide range of STEM and STEAM-based competitions, workshops, exhibitions, and hands-on projects. Over the past two decades, it has engaged thousands of students and educators, promoting space awareness across academic levels. The celebration continues to ignite curiosity, cultivate innovation, and empower the next generation to pursue careers in space science and contribute to a peaceful and sustainable space future.',
    images: [
      WSW2013One,
      WSW2013Two,
      WSW2014One,
      WSW2014Two,
      WSW2015,
      WSW2016,
      WSW2017,
      WSW2018,
    ],
    link: '/world-space-week',
  },

  {
    title: 'Astronomy Outreach',
    description:
      'Astronomy Outreach is a key initiative of the Space Education and Research Lab (SERL) at the National Center of GIS and Space Applications (NCGSA), designed to bring the wonders of the universe closer to students, communities, and the general public. Through astronomy education, guided stargazing sessions, and collaborative outreach, the program fosters curiosity, encourages scientific thinking, and nurtures a deeper connection with the cosmos. Inclusive and dynamic, it continues to inspire space enthusiasts across academic and public platforms nationwide.',
    images: [
      AstronomyCamp,
      AstrophotographyWorkshop,
      ISTObservatory,
      SolarObservation,
      Stargazing,
    ],
    link: '/astronomy-outreach',
  },

  {
    title: 'Student Satellite Outreach',
    description:
      'Student Satellite Development Outreach is an innovative program by the Space Education and Research Lab (SERL) at the National Center of GIS and Space Applications (NCGSA), designed to provide students with hands-on experience in satellite systems engineering. Centered on CanSat and CubeSat mission design, the program takes learners through the complete satellite development lifecycle,from mission planning and subsystem integration to testing and launch. Through immersive workshops, expert mentoring, and national challenges, students gain practical skills in embedded systems, hardware design, and real-time data acquisition. Reaching over 1,500 students across Pakistan, the program fosters technical competence, teamwork, and a passion for space innovation.',
    images: [SSO, CanSatWorkshop, CanSatAssembly, CanSatFieldActivity],
    link: '/student-satellite-outreach',
  },

  {
    title: 'Space Destination Schools',
    description:
      'Space Destination Schools is a grassroots outreach initiative of the Space Education and Research Lab (SERL) at the National Center of GIS and Space Applications (NCGSA), designed to bring space education to remote and underserved regions of Pakistan. Through short-term, immersive learning camps hosted at selected schools and open to neighboring institutions, the program engages students in interactive lectures, hands-on workshops, and creative activities across Astronomy, Earth Science, Aviation, Rocketry, and Satellite Technology. By transforming schools into vibrant space learning hubs, the initiative has reached over 2,000 students from 150+ schools, igniting curiosity and inspiring the next generation of space thinkers and innovators.',
    images: [
      SpaceScienceDemonstration,
      SchoolLaboratory,
      KalamStudents,
      HandsOnSchoolActivity,
      STEMClassroom,
    ],
    link: '#',
  },

  {
    title: 'Space Outreach TeleFilm',
    description:
      'Space Outreach Telefilm is a creative science communication initiative that leverages cinematic storytelling to explore the role of space technology in addressing climate change and environmental challenges. Developed through a collaboration between faculty, researchers, and filmmakers, the telefilm transforms complex scientific ideas into an engaging and relatable narrative. Drawing on academic research, surveys, and workshops, it highlights the importance of space-based solutions for disaster preparedness and sustainability. As a powerful outreach tool, the project bridges science and storytelling to spark awareness, foster dialogue, and inspire meaningful action.',
    images: [
      JABH,
      TelefilmPremiereGroup,
      TelefilmCastGroup,
      TelefilmPremiereAudience,
      TelefilmPremiereStage,
    ],
    link: '#',
  },
];


const EventsOutreach = () => {
    const screens = useBreakpoint();
  return (
    <>
      <AppHeader />


      {/* =====================================================
          HERO BANNER
          ===================================================== */}

      <section
        className="outreach-hero-banner"
        role="img"
        aria-label="Events and Outreach"
      />


      {/* =====================================================
          MAIN PAGE
          ===================================================== */}

      <main className="outreach-page">

        <div className="outreach-container">


          {/* =================================================
              PAGE INTRODUCTION
              ================================================= */}

          <section className="outreach-introduction">

            <Title
              level={1}
              className="outreach-page-title"
            >
              Space Awareness & Outreach 
            </Title>

            <div className="outreach-title-line" />

            <Paragraph  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }}  className="outreach-intro-text">
              The National Center of GIS and Space Applications (NCGSA)
              leads a dedicated space awareness and outreach initiative
              that engages individuals of all ages in exploring the wonders
              and applications of space science and technology. Through a
              wide range of carefully designed events, seminars,
              educational experiences, and creative engagements, the
              initiative promotes space literacy, fosters curiosity, and
              encourages active participation in the growing space ecosystem.
              It aims to inspire minds, bridge knowledge gaps, and nurture
              a culture of scientific exploration and innovation.
            </Paragraph>

          </section>


          {/* =================================================
              PROGRAM HEADING
              ================================================= */}

         


          {/* =================================================
              EVENTS
              ================================================= */}

          <section className="outreach-events-list">

            {events.map((event, index) => (

              <article
                className={`outreach-event-card ${
                  index % 2 === 1
                    ? 'outreach-event-card-reverse'
                    : ''
                }`}
                key={event.title}
              >


                {/* IMAGE */}

                <div className="outreach-event-image-column">

                  {event.images ? (

                    <Carousel
                      autoplay
                      autoplaySpeed={3500}
                      dots
                      className="outreach-event-slider"
                    >
                      {event.images.map((eventImage, imageIndex) => (
                        <div className="outreach-event-slide" key={eventImage}>
                          <img
                            src={eventImage}
                            alt={`${event.title} activity ${imageIndex + 1}`}
                            className="outreach-event-slider-image"
                          />
                        </div>
                      ))}
                    </Carousel>

                  ) : event.image ? (

                    <img
                      src={event.image}
                      alt={event.title}
                      className="outreach-event-image"
                    />

                  ) : (

                    <div className="outreach-image-placeholder">

                      <CalendarOutlined />

                      <span>Event Image</span>

                    </div>

                  )}

                </div>


                {/* CONTENT */}

                <div className="outreach-event-content">

                  <span className="outreach-event-number">
                    {String(index + 1).padStart(2, '0')}
                  </span>

                  <Title
                    level={2}
                    className="outreach-event-title"
                  >
                    {event.title}
                  </Title>

                  <div className="outreach-event-line" />

                  <Paragraph style={{
            fontSize: screens.xs ? '20px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }}  className="outreach-event-description">
                    {event.description}
                  </Paragraph>

                  <a
                    href={event.link}
                    className="outreach-event-link"
                  >
                    Explore Program

                    <ArrowRightOutlined />
                  </a>

                </div>

              </article>

            ))}

          </section>

        </div>

      </main>


      <FooterComponent />
    </>
  );
};


export default EventsOutreach;
